import React from "react";

import { useSelector } from "react-redux";

import { FaInfoCircle } from "react-icons/fa";
import InfoPopupHover from "../components/InfoPopupHover";

export default function TravelFilter(props) {
  const { changeFilterAndSearch } = props;
  const loading = useSelector((state) => state.system.loading);
  const transferincluded = useSelector(
    (state) => state.search.transferincluded
  );
  const railandfly = useSelector((state) => state.search.railandfly);
  const holidayType = useSelector((state) => state.search.holidayType);
  const directflight = useSelector((state) => state.search.directflight);
  const rentalcar = useSelector((state) => state.search.rentalcar);

  const infos = useSelector((state) => state.properties.infos);

  return (
    <div
      className="travelfilter"
      style={{
        border: "1px solid #d0d0d0",
        backgroundColor: "white",
        marginBottom: 16,
        padding: 16,
      }}
    >
      <div className="travelfilter1 filterheader">Reise</div>
      {holidayType.flight && (
        <div className="filterrow">
          <div className="filter1">
            <input
              className="travelfilter3"
              disabled={loading > 0}
              type="checkbox"
              checked={transferincluded}
              onChange={() =>
                changeFilterAndSearch("transferincluded", !transferincluded)
              }
            />
          </div>
          <div className="filter2">
            <div
              className="filtertext"
              dangerouslySetInnerHTML={{
                __html: "inkl. Hoteltransfer im Zielgebiet",
              }}
            ></div>
            <InfoPopupHover
              trigger={
                <span>
                  <FaInfoCircle className="filterinfo" />
                </span>
              }
              content={infos.ink_hoteltransfer_im_zielgebiet}
              position={"right center"}
            ></InfoPopupHover>
          </div>
        </div>
      )}
      {holidayType.flight && (
        <div className="filterrow">
          <div className="filter1">
            <input
              className="travelfilter5"
              disabled={loading > 0}
              type="checkbox"
              checked={railandfly}
              onChange={() => changeFilterAndSearch("railandfly", !railandfly)}
            />
          </div>
          <div className="filter2">
            <div
              className="filtertext"
              dangerouslySetInnerHTML={{
                __html: "Zug zum Flug inklusive",
              }}
            ></div>
            <InfoPopupHover
              trigger={
                <span>
                  <FaInfoCircle className="filterinfo" />
                </span>
              }
              content={infos.zug_zum_flug_inklusive}
              position={"right center"}
            ></InfoPopupHover>
          </div>
        </div>
      )}
      <div className="filterrow">
        <div className="filter1">
          <input
            className="travelfilter5"
            disabled={loading > 0}
            type="checkbox"
            checked={rentalcar}
            onChange={() => changeFilterAndSearch("rentalcar", !rentalcar)}
          />
        </div>
        <div className="filter2">
          <div
            className="filtertext"
            dangerouslySetInnerHTML={{
              __html: "inkl. Mietwagen",
            }}
          ></div>
          {/*<InfoPopupHover
            trigger={
              <span>
                <FaInfoCircle className="filterinfo" />
              </span>
            }
            content={infos.zug_zum_flug_inklusive}
            position={"right center"}
          ></InfoPopupHover>*/}
        </div>
      </div>
      {holidayType.flight && (
        <div className="filterrow">
          <div className="filter1">
            <input
              className="travelfilter7"
              disabled={loading > 0}
              type="checkbox"
              checked={directflight}
              onChange={() =>
                changeFilterAndSearch("directflight", !directflight)
              }
            />
          </div>
          <div className="filter2">
            <div
              className="filtertext"
              dangerouslySetInnerHTML={{
                __html: "Direktflug",
              }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
}
